import * as React from 'react';

import { cn } from '@/shared/utils/index';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
	({ className, type, ...props }, ref) => {
		return (
			<input
				type={type}
				className={cn(
					'file:text-foreground focus-visible:ring-ring flex h-12 w-full rounded-lg border bg-transparent px-4 py-1 text-base transition-colors file:border-0 file:bg-transparent placeholder:text-gray-3 autofill:bg-transparent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-3 disabled:cursor-not-allowed disabled:opacity-50 has-[autofill]:bg-transparent',
					className,
				)}
				ref={ref}
				{...props}
			/>
		);
	},
);
Input.displayName = 'Input';

export { Input };
